export default {
    OPEN_STATE: {
        2: '开户中',
        3: '开户成功',
        4: '开户失败'
    },
    OPEN_STATE_ENUM: {
        onProcess: 2,
        success: 3,
        failed: 4
    },
    STATE: {
        0: '停用',
        1: '启用'
    },
    STATE_ENUM: {
        disable: 0,
        enable: 1
    }   
}